export default __webpack_public_path__ + "static/media/aboutCloudeSecurity_bg.39b05cd9.jpg";